module.exports = __webpack_public_path__ + "img/icon-gray-left.d34ee775.svg";